import React from "react";

import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";

import UserForm from "./UserForm";
import { useTranslation } from "react-i18next";
const DigitalSolution = () => {
  const { t } = useTranslation();
  return (
    <div className="ds">
      <Grid container className="digital-solution-page ">
        <Grid item md={6} xs={12} className=" padding-left-col left-align">
          <Box>
            {/* <SingleImageBox imgSrc={DigitalSolutionLogo} /> */}
            <Box component="div" display="flex" justifyContent="center">
              <Box component="div" width="fit-content">
                <Typography variant="h2" fontWeight="bold" color="black">
                  {t("digital-solution.heading-1")}
                </Typography>
                <Typography variant="h2" fontWeight="bold" className="heading">
                  {t("digital-solution.heading-2")}
                </Typography>
              </Box>
            </Box>
            <Typography variant="subtitle2" className="info-text ">
              {t("digital-solution.description-1")}
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              {t("digital-solution.description-2")}
            </Typography>
          </Box>
        </Grid>
        {/* <Grid item md={6} xs={12}></Grid> */}
        {/* <BgImageBox /> */}
        <Grid item xs={12}>
          <UserForm />
        </Grid>
      </Grid>
    </div>
  );
};

export default DigitalSolution;
